import { webEnv as env } from "@revana/env";
import { type CookieSerializeOptions } from "cookie";

import getCookieDomain from "./get-cookie-domain";

export const ADMIN_EMAILS = [
  "team@tryrevana.com",
  "aribkhan2004@gmail.com",
  "subraizahmed@gmail.com",
  "kohl@musicfy.lol",
];

type TAdminCheck = {
  user: {
    email: string;
  };
} | null;

export const checkIsAdmin = (session: TAdminCheck) => {
  if (!session) return false;
  return (
    ADMIN_EMAILS.includes(session.user.email.toLowerCase()) ||
    env.NEXT_PUBLIC_VERCEL_ENV === "development"
  );
};

export const getBaseUrl = () => {
  if (typeof window !== "undefined") return window.location.origin;
  if (env.VERCEL_URL) return `https://${env.VERCEL_URL}`;

  return `http://localhost:${process.env.PORT ?? 3000}`;
};

export const getProductionUrl = () => {
  if (typeof window !== "undefined") return window.location.origin;
  if (env.VERCEL_URL) return `https://${env.VERCEL_PROJECT_PRODUCTION_URL}`;

  return `http://localhost:${process.env.PORT ?? 3000}`;
};

export const STORE_COOKIE_NAME = "current-store-id";
export const STORE_COOKIE_OPTIONS: CookieSerializeOptions = {
  secure: false,
  sameSite: "lax" as const,
  path: "/",
  domain: getCookieDomain(),
  expires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
};
